import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

const defaultDocuments = [
  "Candidates work",
  "Attendance list",
  "Scoring guide",
  "Mark sheet",
  "Report"
];

function ExamTypesCreate() {
  const [typeName, setTypeName] = useState('');
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [tooltip, setTooltip] = useState('');
  const navigate = useNavigate();

  const handleDocumentChange = (doc, checked) => {
    if (checked) {
      setSelectedDocuments([...selectedDocuments, doc]);
    } else {
      setSelectedDocuments(selectedDocuments.filter(d => d !== doc));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { name: typeName, requiredDocuments: selectedDocuments };
    axios.post('/api/exam-types', payload)
      .then(() => {
        setTooltip('Exam type created successfully!');
        setTimeout(() => navigate('/admin/exam-types/view'), 2000);
      })
      .catch(() => setTooltip('Error creating exam type.'));
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create Exam Type" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Exam Type Name</label>
              <input 
                type="text" 
                className="form-control"
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Required Documents</label>
              <div>
                {defaultDocuments.map(doc => (
                  <div className="form-check form-check-inline" key={doc}>
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id={`doc-${doc}`} 
                      value={doc} 
                      checked={selectedDocuments.includes(doc)}
                      onChange={(e) => handleDocumentChange(doc, e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor={`doc-${doc}`}>
                      {doc}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <button type="submit" className="btn btn-primary">Create Exam Type</button>
          </form>
        </div>
      </div>
      {tooltip && (
        <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default ExamTypesCreate;
